import {
    getClassTypeList,
    postClassType,
    updateClassType,
    deleteClassType,
  } from "@/services/class-type.service";

  import { setPaginationDetails } from "../../utils/utils";
  
  // initial state
  const state = () => ({
    classTypeModel: {},
  });
  
  // mutations
  const mutations = {
    setClassTypeModel(state, data) {
      state.classTypeModel = data;
    },
  };
  
  // actions
  const actions = {
    //Etkinlik Listesi
    async loadClassTypeList(vuexContext, co) {
      return await getClassTypeList(co).then((response) => {
        let data = response.data.data;
        let items = data.items;
        let totalCount = data.totalCount;
        let totalPages = data.totalPages;
  
        items.map((item, index) => {
          item.index = index + 1;
        });
  
        setPaginationDetails(co, totalCount, totalPages);
  
        return items;
      });
    },
  
    async postClassType(vuexContext, data) {
      return await postClassType(data).then((response) => {
        let data = response;
        return data;
      });
    },
  
    async updateClassType(vuexContext, data) {
      return await updateClassType(data).then((response) => {
        let data = response;
        return data;
      });
    },
  
    async deleteClassType(vuexContext, data) {
      return await deleteClassType(data).then((response) => {
        let data = response;
        return data;
      });
    },
  
    addClassTypeModel(vuexContext, data) {
      vuexContext.commit("setClassTypeModel", data);
    },
  };
  
  // getters
  const getters = {};
  
  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
  